// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1khIZ","vLegacy":"SelectSecondary_vLegacy__2b7FK","error":"SelectSecondary_error__1fSgZ","disabled":"SelectSecondary_disabled__2bPmt"};